<template>
  <div class="home">
    <el-row style="margin-top: 70px; width: 1252px; margin-left: auto; margin-right: auto;">
      <el-col :span="6">
        <div class="card" style="width: 260px; height: 400px; background-color: rgb(60, 102, 152); border: none;">
          <img src="/static/展会责任险.2ee4da04.jpg" class="card-img-top">
          <div class="card-body"><h5 class="card-title" style="color: white;">保险安全保障</h5>
            <!-- <p class="card-text" style="color: white;">专业风险评估</p>
            <p class="card-text" style="color: white;">审核保单是否符合展会的风险管理要求</p>
            <p class="card-text" style="color: white;">建议展会各方配置展览会责任险来转移展会过程中的风险。</p> -->
          </div><a class="btn product-btn mx-auto d-block mb-4" href="http://zzb.dlbxjj.com/exhibition-insurance">立即投保</a>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="col-3 p-0"><div class="card" style="width: 260px; height: 400px; background-color: rgb(60, 102, 152); border: none;">
          <img src="/static/公众责任险.3113cab9.jpg" class="card-img-top">
          <div class="card-body"><h5 class="card-title" style="color: white;">展会详情</h5>
          <p class="card-text" style="color: white;">提供展会的查询服务</p>
          </div><a class="btn product-btn mx-auto d-block mb-4" href="/exhibition-info">立即查询</a></div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="col-3 p-0"><div class="card" style="width: 260px; height: 400px; background-color: rgb(60, 102, 152); border: none;">
          <img src="/static/定制保险.43f5a76e.jpg" class="card-img-top"><div class="card-body"><h5 class="card-title" style="color: white;">安全顾问服务</h5>
          <p class="card-text" style="color: white;">专业的展会安全顾问，为您提供专业的展会安全保障解决方案！</p>
          </div><a class="btn product-btn mx-auto d-block mb-4" href="/">即将推出</a></div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="col-3 p-0"><div class="card" style="width: 260px; height: 400px; background-color: rgb(60, 102, 152); border: none;">
          <img src="/static/资料下载.01dbc5b3.jpg" class="card-img-top">
          <div class="card-body"><h5 class="card-title" style="color: white;">资料下载</h5>
          <p class="card-text" style="color: white;">资料下载</p>
          </div><a class="btn product-btn mx-auto d-block mb-4" href="/miscdownload">即将推出</a></div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="重要提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>尊敬的客户：保单变更或退保，需要投保人在保单生效前提交书面申请（非工作日无法受理），承保结束后无法退保，请您知晓！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      centerDialogVisible:true
    }

  },

  
  
}
</script>

<style scoped>
.p-0 {
    padding: 0!important;
}
.col-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
*, :after, :before {
    box-sizing: border-box;
    box */: ;
}
.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
}

.card-img-top {
    width: 100%;
    border-top-left-radius: calc(.25rem - 1px);
    border-top-right-radius: calc(.25rem - 1px);
}

.card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
}

.card-title {
    margin-bottom: .75rem;
}

.h5, h5 {
    font-size: 1.25rem;
}

h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: .5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
}

.card-subtitle, .card-text:last-child {
    margin-bottom: 0;
}

p {
    margin-top: 0;
    margin-bottom: 1em;
}

.btn.product-btn {
    border: solid #06e2d6;
    width: 105px;
    background-color: #3c6698;
    color: #06e2d6;
}

.ml-auto, .mx-auto {
    margin-left: auto!important;
}

.mr-auto, .mx-auto {
    margin-right: auto!important;
}

.mb-4, .my-4 {
    margin-bottom: 1.5rem!important;
}

.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

a {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    -webkit-transition: color .3s;
    transition: color .3s;
    -webkit-text-decoration-skip: objects;
}

body {
    margin: 0;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    font-variant: tabular-nums;
    line-height: 1.5;
    background-color: #fff;
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum","tnum";
}
</style>
